import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {
	AbsoluteFill,
	Composition,
	Easing,
	interpolate,
	useCurrentFrame,
	useVideoConfig,
} from 'remotion';
import {EXPLORE_CAMERA_ANGLE} from './HomepageAssets/ExploreRemotion/camera-angle';

export const RenderModalCodecPreview = () => {
	const {fps} = useVideoConfig();
	const frame = (useCurrentFrame() * 60) / fps;

	return (
		<AbsoluteFill
			name="Canvas Capture"
			style={{
				width: 3084,
				height: 3588,
				translate: '-946.8px -905.4px',
				rotate: EXPLORE_CAMERA_ANGLE,
				transformOrigin: '27.8% 28.65%',
				scale: 0.933,
			}}
			trimBefore={(585 / 60) * fps}
		>
			<Video
				src="https://remotion.media/canvas-capture/render-modal-codec-2026-09-21.webm"
				muted
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[
						-579, -532, -531, -530, -446, -399, -370, -345, -234, -164, -156,
						-153, -150, -144, -142, -138, -94, -84, 126, 127, 135, 136, 140,
						141, 151, 158, 243,
					],
					[
						'auto',
						'row-resize',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'text',
						'auto',
						'default',
						'ew-resize',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
						'default',
						'auto',
					],
					{
						easing: [
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
							Easing.step1,
						],

						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[
							-585, -488, -481, -375, -367, -198, -190, -114, -107, 89, 97, 180,
							187, 324, 330,
						],
						[5, 4.5, 5, 4.5, 5, 4.5, 5, 4.5, 5, 4.5, 5, 4.5, 5, 4.5, 5],
						{
							easing: [
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
								Easing.step1,
							],
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							-579, -578, -572, -571, -570, -569, -568, -567, -566, -565, -562,
							-561, -560, -558, -557, -556, -555, -554, -553, -552, -551, -550,
							-547, -546, -545, -544, -543, -542, -541, -540, -539, -538, -537,
							-536, -535, -534, -533, -532, -531, -530, -529, -528, -527, -526,
							-525, -524, -523, -522, -521, -520, -519, -485, -484, -483, -447,
							-446, -445, -444, -443, -442, -441, -440, -439, -438, -437, -436,
							-435, -434, -433, -432, -431, -430, -429, -428, -427, -426, -425,
							-424, -423, -422, -421, -420, -419, -418, -417, -416, -415, -414,
							-413, -412, -411, -410, -409, -408, -407, -406, -405, -404, -403,
							-402, -401, -400, -399, -398, -397, -396, -395, -394, -393, -392,
							-391, -390, -389, -371, -370, -369, -349, -348, -347, -346, -345,
							-344, -343, -342, -341, -340, -339, -338, -337, -336, -335, -334,
							-333, -332, -331, -330, -329, -328, -327, -326, -325, -324, -323,
							-322, -321, -320, -319, -318, -317, -316, -315, -314, -313, -312,
							-311, -310, -309, -308, -307, -306, -305, -304, -303, -302, -301,
							-300, -299, -298, -297, -296, -295, -294, -293, -292, -291, -290,
							-289, -288, -287, -286, -285, -284, -283, -282, -281, -280, -279,
							-278, -277, -276, -275, -274, -273, -272, -271, -270, -269, -268,
							-267, -266, -265, -264, -263, -262, -261, -260, -259, -258, -257,
							-256, -255, -254, -253, -252, -251, -250, -249, -248, -247, -246,
							-245, -244, -243, -242, -241, -240, -239, -238, -237, -236, -235,
							-234, -233, -232, -231, -230, -229, -228, -227, -226, -225, -224,
							-223, -222, -221, -220, -219, -218, -217, -216, -215, -214, -213,
							-212, -211, -210, -209, -207, -206, -205, -193, -192, -191, -190,
							-166, -165, -164, -163, -162, -161, -160, -159, -158, -157, -156,
							-155, -154, -153, -152, -151, -150, -149, -148, -147, -146, -145,
							-144, -143, -142, -141, -140, -139, -138, -137, -136, -135, -134,
							-133, -132, -131, -130, -129, -128, -127, -126, -125, -95, -94,
							-93, -92, -91, -90, -89, -88, -87, -86, -85, -84, -83, -82, -81,
							-80, -79, -78, -77, -76, -75, -74, -73, -72, -71, -70, -69, -68,
							-67, -66, -65, -64, -63, -62, -61, -60, -59, -58, -57, -56, -55,
							-54, -53, -52, -51, -50, -49, -48, -47, -46, -45, -44, -43, -42,
							-41, -40, -39, -38, -37, -36, -35, -34, -33, -32, -31, -30, -29,
							-28, -27, -26, -25, -24, -23, -22, -21, -20, -19, -18, -17, -16,
							-15, -14, -13, -12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1,
							0, 1, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41,
							42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
							58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73,
							74, 75, 76, 77, 78, 79, 125, 126, 127, 128, 129, 130, 131, 132,
							133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145,
							146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158,
							159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 242, 243,
							244, 245, 246, 247, 257, 258, 259, 260, 261, 262, 263, 264, 265,
							267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279,
							280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 291, 292, 293,
							294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
							307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
						],
						[
							'575px 4426.5625px',
							'788.4375px 4338.0078125px',
							'788.4375px 4338.0078125px',
							'4125.78125px 2696.5625px',
							'4128.828125px 2695.05859375px',
							'4128.828125px 2695.05859375px',
							'4128.14453125px 2694.70703125px',
							'4123.65234375px 2693.96484375px',
							'4121.9140625px 2693.75px',
							'4121.875px 2693.75px',
							'4121.875px 2693.75px',
							'4121.640625px 2693.75px',
							'4121.11328125px 2693.75px',
							'4121.11328125px 2693.75px',
							'4119.7265625px 2695.87890625px',
							'4105.01953125px 2712.91015625px',
							'4066.97265625px 2754.0625px',
							'4066.97265625px 2754.0625px',
							'4022.0703125px 2800.95703125px',
							'4005.33203125px 2820.72265625px',
							'3998.203125px 2829.12109375px',
							'3995.5078125px 2832.59765625px',
							'3995.5078125px 2832.59765625px',
							'3995.52734375px 2831.42578125px',
							'3995.52734375px 2831.42578125px',
							'4001.9140625px 2765.3125px',
							'4016.9921875px 2639.08203125px',
							'4022.91015625px 2525.91796875px',
							'4028.7890625px 2445.37109375px',
							'4026.19140625px 2377.87109375px',
							'4020.9765625px 2353.37890625px',
							'4018.6328125px 2340.33203125px',
							'4017.6953125px 2326.171875px',
							'4017.6953125px 2304.94140625px',
							'4017.6953125px 2286.2109375px',
							'4018.0078125px 2260.01953125px',
							'4018.96484375px 2218.4765625px',
							'4018.96484375px 2184.7265625px',
							'4017.40234375px 2162.98828125px',
							'4014.23828125px 2146.54296875px',
							'4012.98828125px 2135.3125px',
							'4012.91015625px 2119.1796875px',
							'4013.57421875px 2108.0859375px',
							'4014.19921875px 2099.82421875px',
							'4014.84375px 2091.953125px',
							'4015.078125px 2090.33203125px',
							'4015.3515625px 2089.1796875px',
							'4015.8203125px 2086.9921875px',
							'4017.34375px 2082.8125px',
							'4018.06640625px 2080.25390625px',
							'4018.10546875px 2080.01953125px',
							'4018.10546875px 2080.01953125px',
							'4018.10546875px 2079.375px',
							'4018.10546875px 2079.2578125px',
							'4018.10546875px 2079.2578125px',
							'4017.40234375px 2079.16015625px',
							'4007.08984375px 2077.98828125px',
							'3968.41796875px 2071.1328125px',
							'3928.9453125px 2047.20703125px',
							'3841.40625px 1986.09375px',
							'3841.40625px 1986.09375px',
							'3532.7734375px 1832.65625px',
							'3439.39453125px 1789.9609375px',
							'3349.140625px 1752.1484375px',
							'3292.96875px 1732.24609375px',
							'3212.265625px 1704.31640625px',
							'3157.6171875px 1686.30859375px',
							'3157.6171875px 1686.30859375px',
							'3127.40234375px 1677.16796875px',
							'3107.5390625px 1669.98046875px',
							'3079.6875px 1659.08203125px',
							'3050.9765625px 1646.77734375px',
							'3011.62109375px 1632.16796875px',
							'2970.95703125px 1615.99609375px',
							'2932.98828125px 1595.9765625px',
							'2894.55078125px 1573.53515625px',
							'2853.26171875px 1549.1796875px',
							'2802.40234375px 1520.2734375px',
							'2741.3671875px 1486.15234375px',
							'2690.56640625px 1456.73828125px',
							'2665.8203125px 1441.26953125px',
							'2640.87890625px 1424.6875px',
							'2628.61328125px 1417.265625px',
							'2611.97265625px 1407.8125px',
							'2594.296875px 1398.96484375px',
							'2555.546875px 1381.19140625px',
							'2517.16796875px 1366.30859375px',
							'2466.40625px 1348.8671875px',
							'2437.32421875px 1340.44921875px',
							'2409.47265625px 1333.26171875px',
							'2385.99609375px 1326.50390625px',
							'2362.20703125px 1320.52734375px',
							'2341.89453125px 1315.0390625px',
							'2323.26171875px 1308.84765625px',
							'2300.7421875px 1300.234375px',
							'2279.82421875px 1290.15625px',
							'2251.34765625px 1275.01953125px',
							'2223.3984375px 1258.9453125px',
							'2189.55078125px 1237.91015625px',
							'2157.4609375px 1217.109375px',
							'2100.3125px 1184.6875px',
							'2074.98046875px 1171.7578125px',
							'2054.82421875px 1160.8203125px',
							'2050.78125px 1158.2421875px',
							'2045.56640625px 1154.66796875px',
							'2036.30859375px 1148.76953125px',
							'2026.3671875px 1141.73828125px',
							'2015.78125px 1133.6328125px',
							'2003.4375px 1124.8046875px',
							'1997.4609375px 1120.8984375px',
							'1990.9765625px 1116.2109375px',
							'1988.984375px 1115.09765625px',
							'1986.71875px 1113.80859375px',
							'1986.71875px 1113.80859375px',
							'1986.1328125px 1113.80859375px',
							'1985.9765625px 1113.80859375px',
							'1985.9765625px 1113.80859375px',
							'1992.08984375px 1141.97265625px',
							'1992.890625px 1157.83203125px',
							'1993.84765625px 1178.4375px',
							'1994.2578125px 1195.44921875px',
							'1994.2578125px 1195.44921875px',
							'1994.2578125px 1209.21875px',
							'1993.53515625px 1216.89453125px',
							'1991.9921875px 1227.34375px',
							'1990.68359375px 1235.41015625px',
							'1988.828125px 1242.40234375px',
							'1988.14453125px 1247.6953125px',
							'1986.50390625px 1257.5px',
							'1985.390625px 1264.9609375px',
							'1985.078125px 1271.6796875px',
							'1985.078125px 1278.57421875px',
							'1984.4921875px 1287.5390625px',
							'1984.3359375px 1293.7890625px',
							'1984.3359375px 1301.09375px',
							'1984.3359375px 1308.671875px',
							'1984.21875px 1316.2109375px',
							'1983.69140625px 1324.140625px',
							'1983.69140625px 1334.12109375px',
							'1983.69140625px 1342.4609375px',
							'1983.69140625px 1348.9453125px',
							'1983.69140625px 1356.6796875px',
							'1983.69140625px 1365.390625px',
							'1983.69140625px 1373.0078125px',
							'1983.69140625px 1377.44140625px',
							'1983.69140625px 1382.578125px',
							'1983.69140625px 1385.4296875px',
							'1983.69140625px 1388.0078125px',
							'1983.69140625px 1390.95703125px',
							'1983.69140625px 1394.4140625px',
							'1983.69140625px 1397.01171875px',
							'1983.69140625px 1400.78125px',
							'1983.984375px 1402.51953125px',
							'1983.984375px 1407.890625px',
							'1983.88671875px 1410.72265625px',
							'1983.4375px 1415.15625px',
							'1983.22265625px 1418.18359375px',
							'1983.02734375px 1420.1953125px',
							'1983.02734375px 1422.265625px',
							'1983.02734375px 1425.078125px',
							'1983.02734375px 1427.51953125px',
							'1983.02734375px 1431.0546875px',
							'1983.02734375px 1434.19921875px',
							'1983.02734375px 1436.89453125px',
							'1982.5px 1442.03125px',
							'1982.5px 1446.71875px',
							'1982.5px 1450.7421875px',
							'1982.5px 1456.25px',
							'1982.03125px 1462.12890625px',
							'1981.93359375px 1468.515625px',
							'1981.19140625px 1478.96484375px',
							'1981.15234375px 1482.91015625px',
							'1981.15234375px 1489.84375px',
							'1981.15234375px 1496.484375px',
							'1981.15234375px 1501.93359375px',
							'1981.15234375px 1505.95703125px',
							'1981.15234375px 1511.3671875px',
							'1980.8984375px 1514.8046875px',
							'1980.80078125px 1519.27734375px',
							'1980.80078125px 1521.58203125px',
							'1980.80078125px 1524.84375px',
							'1980.80078125px 1527.2265625px',
							'1980.80078125px 1531.71875px',
							'1980.80078125px 1535.8984375px',
							'1980.80078125px 1541.0546875px',
							'1980.52734375px 1546.58203125px',
							'1980.37109375px 1553.73046875px',
							'1980.37109375px 1558.45703125px',
							'1980.37109375px 1563.92578125px',
							'1980.37109375px 1567.0703125px',
							'1980.37109375px 1572.421875px',
							'1980.37109375px 1578.61328125px',
							'1980.37109375px 1582.8515625px',
							'1980.37109375px 1588.02734375px',
							'1980.37109375px 1592.16796875px',
							'1980.37109375px 1598.8671875px',
							'1980.37109375px 1605.56640625px',
							'1980.37109375px 1613.59375px',
							'1980.37109375px 1615.8203125px',
							'1980.37109375px 1621.85546875px',
							'1980.37109375px 1626.54296875px',
							'1980.37109375px 1631.30859375px',
							'1980.37109375px 1634.765625px',
							'1980.37109375px 1639.21875px',
							'1980.37109375px 1642.67578125px',
							'1980.37109375px 1645.625px',
							'1980.37109375px 1648.125px',
							'1980.9765625px 1653.2421875px',
							'1980.9765625px 1655.17578125px',
							'1980.9765625px 1657.91015625px',
							'1980.9765625px 1660.5859375px',
							'1980.9765625px 1664.0625px',
							'1981.25px 1667.63671875px',
							'1981.40625px 1670.80078125px',
							'1981.40625px 1673.45703125px',
							'1981.40625px 1676.85546875px',
							'1981.40625px 1680.9375px',
							'1981.484375px 1683.671875px',
							'1981.97265625px 1686.015625px',
							'1982.5px 1688.65234375px',
							'1983.046875px 1691.77734375px',
							'1983.2421875px 1694.375px',
							'1983.65234375px 1697.265625px',
							'1983.7109375px 1700.05859375px',
							'1983.7109375px 1703.203125px',
							'1984.43359375px 1710.9375px',
							'1984.43359375px 1715.21484375px',
							'1984.43359375px 1723.0078125px',
							'1984.43359375px 1730.1953125px',
							'1984.43359375px 1734.6484375px',
							'1984.43359375px 1739.2578125px',
							'1984.43359375px 1746.0546875px',
							'1984.43359375px 1754.0234375px',
							'1984.08203125px 1757.63671875px',
							'1984.00390625px 1766.4453125px',
							'1983.30078125px 1774.0234375px',
							'1982.51953125px 1783.515625px',
							'1981.81640625px 1793.203125px',
							'1981.171875px 1800.78125px',
							'1980.3515625px 1811.875px',
							'1979.39453125px 1827.36328125px',
							'1978.65234375px 1839.08203125px',
							'1978.0859375px 1845.99609375px',
							'1978.0859375px 1855.390625px',
							'1978.0859375px 1860.1953125px',
							'1978.0859375px 1868.45703125px',
							'1978.0859375px 1873.73046875px',
							'1978.0859375px 1880.078125px',
							'1978.0859375px 1884.23828125px',
							'1978.0859375px 1886.1328125px',
							'1978.0859375px 1888.0859375px',
							'1978.0859375px 1890.95703125px',
							'1978.0859375px 1892.79296875px',
							'1978.26171875px 1894.62890625px',
							'1978.61328125px 1896.4453125px',
							'1978.7890625px 1897.6171875px',
							'1979.00390625px 1898.046875px',
							'1979.00390625px 1898.046875px',
							'1979.00390625px 1898.69140625px',
							'1979.00390625px 1899.2578125px',
							'1979.00390625px 1899.2578125px',
							'1979.3359375px 1899.2578125px',
							'1980.0390625px 1899.5703125px',
							'1980.2734375px 1899.8046875px',
							'1980.2734375px 1899.8046875px',
							'1980.2734375px 1895.87890625px',
							'1984.35546875px 1857.8515625px',
							'1987.34375px 1820.1953125px',
							'1987.34375px 1796.62109375px',
							'1986.73828125px 1780.05859375px',
							'1985.76171875px 1760.1953125px',
							'1984.0625px 1739.375px',
							'1984.0625px 1714.1796875px',
							'1984.0625px 1689.12109375px',
							'1984.43359375px 1663.5546875px',
							'1984.84375px 1648.88671875px',
							'1985.44921875px 1633.59375px',
							'1985.703125px 1620.25390625px',
							'1986.484375px 1605.01953125px',
							'1986.54296875px 1591.34765625px',
							'1986.54296875px 1570.21484375px',
							'1986.54296875px 1549.12109375px',
							'1986.07421875px 1537.578125px',
							'1984.62890625px 1526.40625px',
							'1983.515625px 1515.17578125px',
							'1982.65625px 1501.19140625px',
							'1981.640625px 1482.6171875px',
							'1980.25390625px 1469.6484375px',
							'1978.7890625px 1458.0078125px',
							'1974.74609375px 1438.92578125px',
							'1970.60546875px 1423.046875px',
							'1964.8046875px 1407.75390625px',
							'1961.15234375px 1398.76953125px',
							'1957.55859375px 1390.83984375px',
							'1955.44921875px 1386.26953125px',
							'1953.90625px 1378.49609375px',
							'1953.1640625px 1371.30859375px',
							'1951.0546875px 1362.59765625px',
							'1950.5078125px 1361.5234375px',
							'1949.35546875px 1359.9609375px',
							'1948.59375px 1358.57421875px',
							'1947.71484375px 1355.95703125px',
							'1946.26953125px 1350.46875px',
							'1945.25390625px 1346.62109375px',
							'1944.4140625px 1344.765625px',
							'1944.2578125px 1344.47265625px',
							'1944.2578125px 1344.47265625px',
							'1944.6484375px 1345.2734375px',
							'1945.91796875px 1348.14453125px',
							'1947.94921875px 1357.0703125px',
							'1948.6328125px 1365.9375px',
							'1949.31640625px 1378.59375px',
							'1949.47265625px 1391.81640625px',
							'1948.90625px 1400.01953125px',
							'1948.90625px 1406.4453125px',
							'1948.7109375px 1413.3203125px',
							'1948.1640625px 1420.625px',
							'1948.1640625px 1426.19140625px',
							'1948.1640625px 1435.234375px',
							'1947.5390625px 1448.046875px',
							'1946.58203125px 1463.80859375px',
							'1945.95703125px 1472.51953125px',
							'1944.98046875px 1489.765625px',
							'1944.23828125px 1505.2734375px',
							'1944.23828125px 1519.39453125px',
							'1943.984375px 1531.5625px',
							'1943.30078125px 1540.95703125px',
							'1942.71484375px 1547.59765625px',
							'1942.51953125px 1551.6796875px',
							'1942.51953125px 1553.30078125px',
							'1942.51953125px 1555.29296875px',
							'1942.51953125px 1556.015625px',
							'1942.51953125px 1557.71484375px',
							'1942.51953125px 1558.57421875px',
							'1942.51953125px 1560.2734375px',
							'1942.7734375px 1562.75390625px',
							'1943.0078125px 1564.43359375px',
							'1943.0078125px 1566.34765625px',
							'1943.45703125px 1568.22265625px',
							'1943.53515625px 1570.4296875px',
							'1943.53515625px 1573.41796875px',
							'1943.53515625px 1577.67578125px',
							'1943.53515625px 1581.7578125px',
							'1943.53515625px 1586.3671875px',
							'1943.10546875px 1593.02734375px',
							'1942.20703125px 1605.09765625px',
							'1941.89453125px 1613.2421875px',
							'1941.89453125px 1619.19921875px',
							'1941.89453125px 1623.125px',
							'1941.89453125px 1628.7109375px',
							'1941.89453125px 1633.49609375px',
							'1941.89453125px 1640.46875px',
							'1942.109375px 1645.8203125px',
							'1942.421875px 1652.05078125px',
							'1942.421875px 1660.52734375px',
							'1942.421875px 1670.4296875px',
							'1942.421875px 1675.46875px',
							'1942.421875px 1682.08984375px',
							'1942.421875px 1690.13671875px',
							'1942.5px 1699.90234375px',
							'1942.8515625px 1705.33203125px',
							'1942.8515625px 1712.83203125px',
							'1943.0859375px 1718.84765625px',
							'1943.30078125px 1726.46484375px',
							'1943.30078125px 1733.57421875px',
							'1943.30078125px 1737.59765625px',
							'1943.30078125px 1744.7265625px',
							'1943.37890625px 1746.875px',
							'1943.76953125px 1749.765625px',
							'1943.76953125px 1753.53515625px',
							'1943.76953125px 1758.28125px',
							'1943.76953125px 1761.73828125px',
							'1943.76953125px 1766.19140625px',
							'1943.76953125px 1770.078125px',
							'1943.76953125px 1774.0625px',
							'1943.76953125px 1779.94140625px',
							'1943.76953125px 1785.29296875px',
							'1943.76953125px 1788.3203125px',
							'1943.76953125px 1791.89453125px',
							'1943.76953125px 1795px',
							'1944.00390625px 1797.890625px',
							'1944.19921875px 1800.9375px',
							'1944.19921875px 1805.60546875px',
							'1944.19921875px 1809.4140625px',
							'1944.66796875px 1813.18359375px',
							'1944.74609375px 1817.28515625px',
							'1945.3125px 1821.9140625px',
							'1945.72265625px 1826.15234375px',
							'1945.99609375px 1830.76171875px',
							'1946.34765625px 1836.7578125px',
							'1946.34765625px 1841.4453125px',
							'1946.640625px 1844.53125px',
							'1947.75390625px 1849.21875px',
							'1947.890625px 1852.05078125px',
							'1947.91015625px 1855.95703125px',
							'1948.41796875px 1859.0234375px',
							'1948.96484375px 1862.4609375px',
							'1949.53125px 1866.25px',
							'1950.3515625px 1869.43359375px',
							'1951.03515625px 1872.0703125px',
							'1951.54296875px 1874.66796875px',
							'1951.66015625px 1876.09375px',
							'1951.66015625px 1876.2109375px',
							'1951.66015625px 1876.2109375px',
							'1951.7578125px 1875.625px',
							'1952.36328125px 1870.95703125px',
							'1952.36328125px 1860.4296875px',
							'1952.36328125px 1858.45703125px',
							'1952.36328125px 1856.6015625px',
							'1952.36328125px 1854.82421875px',
							'1951.9921875px 1853.33984375px',
							'1951.8359375px 1850.1171875px',
							'1951.8359375px 1847.32421875px',
							'1951.7578125px 1833.515625px',
							'1951.7578125px 1833.515625px',
							'1951.09375px 1824.6875px',
							'1950.8984375px 1819.296875px',
							'1950.6640625px 1816.42578125px',
							'1950.41015625px 1813.88671875px',
							'1950.21484375px 1810.2734375px',
							'1949.9609375px 1808.02734375px',
							'1949.8828125px 1803.125px',
							'1949.39453125px 1799.140625px',
							'1948.76953125px 1793.3984375px',
							'1948.76953125px 1791.03515625px',
							'1948.515625px 1785.95703125px',
							'1948.0078125px 1778.33984375px',
							'1948.0078125px 1769.5703125px',
							'1948.0078125px 1759.2578125px',
							'1948.0078125px 1751.40625px',
							'1948.0078125px 1748.0859375px',
							'1948.0078125px 1743.6328125px',
							'1948.0078125px 1737.79296875px',
							'1948.0078125px 1733.84765625px',
							'1948.0078125px 1730.29296875px',
							'1948.359375px 1724.1015625px',
							'1948.76953125px 1715.68359375px',
							'1949.12109375px 1709.0234375px',
							'1949.296875px 1703.65234375px',
							'1949.296875px 1698.18359375px',
							'1949.296875px 1689.921875px',
							'1949.9609375px 1682.34375px',
							'1950.703125px 1673.5546875px',
							'1951.15234375px 1666.73828125px',
							'1951.15234375px 1661.6796875px',
							'1951.15234375px 1658.203125px',
							'1951.15234375px 1652.0703125px',
							'1951.15234375px 1646.953125px',
							'1951.6796875px 1641.5625px',
							'1951.73828125px 1639.78515625px',
							'1951.73828125px 1639.3359375px',
							'1951.73828125px 1637.48046875px',
							'1951.73828125px 1636.328125px',
							'1951.73828125px 1636.0546875px',
							'1951.73828125px 1635.546875px',
							'1951.73828125px 1635.33203125px',
							'1951.73828125px 1635.33203125px',
							'1950.99609375px 1635.33203125px',
							'1946.19140625px 1623.57421875px',
							'1945.25390625px 1603.73046875px',
							'1944.86328125px 1591.62109375px',
							'1942.734375px 1576.38671875px',
							'1939.70703125px 1556.015625px',
							'1936.81640625px 1535.95703125px',
							'1933.80859375px 1513.92578125px',
							'1928.65234375px 1475.48828125px',
							'1922.421875px 1420.5078125px',
							'1916.6796875px 1373.30078125px',
							'1903.33984375px 1308.22265625px',
							'1889.23828125px 1259.5703125px',
							'1876.54296875px 1217.28515625px',
							'1866.8359375px 1184.8046875px',
							'1860.5078125px 1149.8046875px',
							'1859.23828125px 1126.34765625px',
							'1858.14453125px 1098.53515625px',
							'1857.98828125px 1080.625px',
							'1857.9296875px 1058.80859375px',
							'1857.1875px 1038.53515625px',
							'1857.1875px 1015.68359375px',
							'1857.1875px 999.43359375px',
							'1857.1875px 981.62109375px',
							'1857.1875px 969.4140625px',
							'1858.671875px 951.6796875px',
							'1859.5703125px 938.828125px',
							'1859.66796875px 922.734375px',
							'1860.234375px 912.9296875px',
							'1860.234375px 900.5859375px',
							'1860.078125px 893.33984375px',
							'1859.74609375px 887.16796875px',
							'1859.74609375px 881.42578125px',
							'1859.74609375px 876.640625px',
							'1859.74609375px 872.65625px',
							'1859.74609375px 869.04296875px',
							'1859.296875px 865.91796875px',
							'1859.27734375px 863.37890625px',
							'1859.27734375px 860.0390625px',
							'1859.08203125px 856.71875px',
							'1858.65234375px 851.97265625px',
							'1858.37890625px 848.33984375px',
							'1858.14453125px 845px',
							'1858.14453125px 844.0625px',
							'1858.14453125px 844.0625px',
							'1858.203125px 844.0625px',
							'1868.73046875px 844.2578125px',
							'1887.1484375px 846.15234375px',
							'1887.1484375px 846.15234375px',
							'1906.23046875px 847.2265625px',
							'1906.23046875px 847.2265625px',
							'1918.22265625px 816.015625px',
							'2031.171875px 669.453125px',
							'2031.171875px 669.453125px',
							'2380.83984375px 444.94140625px',
							'3123.88671875px -13.4375px',
							'3763.4765625px -699.9609375px',
							'3848.02734375px -824.90234375px',
							'3854.4921875px -839.23828125px',
							'3854.4921875px -839.23828125px',
							'3852.94921875px -837.71484375px',
							'3766.2890625px -706.7578125px',
							'3536.953125px -340.44921875px',
							'3162.36328125px 327.7734375px',
							'2855.6640625px 890.234375px',
							'2391.3671875px 1793.0078125px',
							'2391.3671875px 1793.0078125px',
							'2075.80078125px 2516.796875px',
							'1569.08203125px 3526.25px',
							'1401.171875px 3773.65234375px',
							'1366.015625px 3823.69140625px',
							'1322.578125px 3887.67578125px',
							'1287.65625px 3922.94921875px',
							'1210.9765625px 3990.91796875px',
							'1114.70703125px 4081.953125px',
							'979.51171875px 4231.2890625px',
							'912.98828125px 4309.1796875px',
							'853.359375px 4366.46484375px',
							'819.453125px 4400.68359375px',
							'786.2890625px 4452.109375px',
							'771.77734375px 4479.00390625px',
							'766.171875px 4488.69140625px',
							'766.171875px 4488.69140625px',
							'765.64453125px 4488.69140625px',
							'758.0859375px 4488.69140625px',
							'737.51953125px 4488.69140625px',
							'709.140625px 4488.69140625px',
							'686.5234375px 4489.4140625px',
							'677.48046875px 4489.921875px',
							'671.5234375px 4489.921875px',
							'670.5859375px 4489.609375px',
							'670.5859375px 4489.609375px',
							'668.3984375px 4487.91015625px',
							'667.265625px 4486.40625px',
							'664.08203125px 4483.45703125px',
							'664.08203125px 4483.45703125px',
							'661.5625px 4480.09765625px',
							'643.984375px 4470.99609375px',
							'635.5859375px 4469.1015625px',
							'633.76953125px 4469.0234375px',
							'631.171875px 4468.57421875px',
							'624.23828125px 4467.83203125px',
							'611.40625px 4466.4453125px',
							'611.40625px 4466.4453125px',
							'589.98046875px 4464.27734375px',
							'571.81640625px 4462.4609375px',
							'555.33203125px 4460.72265625px',
							'543.30078125px 4458.61328125px',
							'527.75390625px 4455.9375px',
							'511.4453125px 4453.4765625px',
							'508.8671875px 4453.046875px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};

export const RenderModalCodec = () => {
	return (
		<Composition
			id={'RenderModalCodec'}
			component={RenderModalCodecPreview}
			width={1920}
			height={1080}
			fps={60}
			durationInFrames={127}
		/>
	);
};
